import { useState, useEffect } from 'react';
import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import { Checkbox } from '@/components/atoms/PcCheckbox';

const STORAGE_KEY = 'monitoring-notice-dismiss-until';

const MonitoringNoticeDialog = () => {
  const [open, setOpen] = useState(false);
  const [dontShowChecked, setDontShowChecked] = useState(false);

  useEffect(() => {
    const dismissUntil = localStorage.getItem(STORAGE_KEY);
    if (dismissUntil && Date.now() < Number(dismissUntil)) {
      return;
    }
    setOpen(true);
  }, []);

  const handleClose = () => {
    if (dontShowChecked) {
      const oneDayLater = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, String(oneDayLater));
    }
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && handleClose()}>
      <DialogContent
        noCloseBtn
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="w-[354px] rounded-[20px] border-none p-[30px] shadow-[0px_4px_20px_0px_rgba(0,0,0,0.12)]"
      >
        <div className="flex flex-col gap-[20px]">
          <div className="flex flex-col gap-[4px]">
            <div className="text-gr-900 Title3S18">상품 추가 기능 일시 중단 안내</div>
            <div className="text-gr-700 Body5M14">
              스마트스토어 상품상세 개편으로 인해
              <br />
              현재 상품 추가 기능을 일시적으로 사용할 수 없습니다.
              <br />
              불편을 드려 죄송합니다.
              <br />
              빠른 시일 내 복구될 수 있도록 최선을 다하겠습니다.
            </div>
          </div>

          <label className="flex w-[260px] cursor-pointer items-center gap-[8px]">
            <Checkbox
              checked={dontShowChecked}
              onCheckedChange={(checked) => setDontShowChecked(!!checked)}
            />
            <span className="text-gr-600 Body5M14">하루동안 보지 않기</span>
          </label>

          <button
            type="button"
            className="h-[44px] w-full cursor-pointer rounded-[8px] border-none bg-gr-100 text-gr-700 Body5M14"
            onClick={handleClose}
          >
            확인
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MonitoringNoticeDialog;
